export default __webpack_public_path__ + "static/media/NUZHAT.631553f0.JPG";